import * as API from '@siloreal:shared:api';

const SATELLITE_CERTIFICATION_ENDPOINT = '/reports/sat/v2/silobags';

export type GenerateSatelliteCertificationServiceContract = {
  silobagIds: readonly string[];
  signal?: AbortSignal;
};

export type GenerateSatelliteCertificationResponse = {
  error: boolean;
  response: unknown;
};

export async function generateSatelliteCertificationService(
  contract: GenerateSatelliteCertificationServiceContract
): Promise<GenerateSatelliteCertificationResponse> {
  if (contract.silobagIds.length === 0) {
    throw new Error('Se necesita al menos un SilosPro para generar la certificación satelital.');
  }

  const serializedIds = contract.silobagIds.map((id) => encodeURIComponent(String(id))).join(',');
  const query = `?silobags=${serializedIds}`;
  const { data } = await API.http.fetch.post<GenerateSatelliteCertificationResponse>(
    SATELLITE_CERTIFICATION_ENDPOINT,
    {
      query,
      signal: contract.signal,
    }
  );

  return data;
}
